var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var Plus = function Plus(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      d: "M13 4.929a1 1 0 1 0-2 0V11H4.93a1 1 0 1 0 0 2H11v6.071a1 1 0 1 0 2 0V13h6.071a1 1 0 1 0 0-2H13V4.929Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default Plus;